module.exports = __webpack_public_path__ + "static/media/client_action.239979ef.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/client_action.md
// module id = 1095
// module chunks = 0